import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

export const ExpenseManagementService = {
  /**  Get Expense List by Manager */
  fetchExpenseList: async () => {
    try {
      const response = await axiosInstance.get(
        API.expenseManagement.getExpenseListBySupervisor);
      return Array.isArray(response.data) ? response.data : []; // enforce array
    } catch (error) {
      console.error("❌ Error fetching expenses:", error);
      return [];
    }
  },

  /**  Update Expense Status */
  updateExpenseStatus: async (expenseManagementId, status) => {
    try {
      const payload = {
        expenseManagementId,
        status,
      };
      const response = await axiosInstance.post(API.expenseManagement.updateStatus, payload);
      return response.data;
    } catch (error) {
      console.error("❌ Error updating status:", error);
      throw error;
    }
  },
};
